/**
 * compaign  adgroup 相关 store
 */
import _ from 'lodash';
import * as service from 'src/service';
import { getUserDraftChecked } from 'src/service/simplifiedSmb';
import { getImpressionService, getRecommendBudgetService, postBackRecommendBudgetService } from 'src/service/budget-recommend/index';
import * as types from 'src/store/types';
import apis from 'src/const/apis';
import { captureError } from 'src/logger/errorLogger';
import request from 'src/utils/request';
import { fetchAreasData, cityOptions2Array } from 'src/const/state/select-province';
import {
  platform as platformEnum, adStatusValues, adgroupIos14Switch, AppStatusValue, AUDIENCE_TYPE, IOS14QuotaType, VOStatus, TargetingExpansionType,
} from 'src/const/state/ad';
import { creativeType, TIKTOK_SEARCH_ADS_SWITCH } from 'src/const/state/creative';
import { INVENTORY_FLOW } from 'src/const/state/inventory-type';
import {
  contentType, campaignObjectiveValue, splitTestType, formatAge, pangleFlowPackConfig, campaignType,
  getAdgroupDCQuota, campaignQuotaSum, checkIsRF,
  buyingType,
} from 'src/const/state/campaign';
import { BudgetSourceType } from 'src/const/state/budget';
import { BrandSafetyMap, SdkS2sAdvertisersIdList, eventStatus } from 'src/const/state/target';
import tool from 'src/utils/tool';
import {
  isAppRetargetWhite,
  isIOS14MultipleWhite,
  isPcmPhase1White,
  isPixelStandardWhite,
  isBudgetReductionEnabled,
  isPcmPhase2White,
  isSplitTestSupportIOS14White,
  isModelSoleWhite,
  isIOS14MultipleTwoWhite,
  isIOS14MultipleFiveWhite,
  isBrandTrackDataWhite,
} from 'src/const/whiteList';
import { LowestBudget } from 'src/mixins/currencyMixin';
import { Scenario } from 'src/const/state/shop';
import { categoryHandler } from 'src/utils/adgroup/index';
import { currencyLocaleFormat } from 'src/utils/currencyUtil';
import { AppProfilePageType } from 'src/const/state/app-profile-page';
import { recommendBudgetRequestFormatter } from 'src/service/budget-recommend/formatter';


const estimateRequestTnterval = 600;
let estimateRequestTimer = null;
let budgetRecommendTimer = null;
let impressionEstimateTimer = null;
const splitTestEstimateRequestTimer = [];

// 从formData中获取dpa的受众预估参数
// eslint-disable-next-line no-unused-vars
function getDpaRetargetParams(data) {
  const {
    product_platform_id,
    dpa_local_audience,
    ad_ref_app_id,
    ad_ref_pixel_id,
    include_custom_actions,
    exclude_custom_actions,
    external_type,
    inventory_flow,
  } = data;
  return {
    dpa_local_audience: dpa_local_audience || AUDIENCE_TYPE.NORMAL.value, // 默认为非重
    product_platform_id,
    ad_ref_app_id,
    ad_ref_pixel_id,
    include_custom_actions,
    exclude_custom_actions,
    external_type,
    inventory_flow,
  };
}

// adgroup local store keys

const adgroup = {
  namespaced: true,
  state: {
    /** AdGroup 表单是否完成了 initCreate/initEdit/initCopy */
    initialized: false,
    loading: false, // next btn loading
    action: 'create',
    activeTab: '1',
    campaign_id: '',
    objective_type: '', // campaign层级的推广目标类型
    classify: 1, // 销买类型
    ad_id: '',
    rf_ad_id: '',
    campaignQuota: {
      available_quota: 0,
      used_quota: 0,
      releasing_quota: 0,
      total_quota: campaignQuotaSum,
    },
    campaignNavList: [],
    adgroupNavList: [],
    adgroupInfo: {}, // 这个对象是接口的单个adgroup,复制用的原始数据，编辑时候也会用到，用来做数据对比
    batchInfo: [], // 复制用的批量修改数据
    copyNumber: 1, // 复制份数
    batchVisible: false, // 控制复制弹窗
    inventory_flow_type: 0, // 0=自动投放，1=placement flow type
    inventory_flow: [], // int  0,all topbuzz:1000，vigo:2000,TIKTOK:3000, OTHER: -1,
    conversion_checked: false, // TODO: pixel全量上线后此逻辑需要下掉，所有改动处均有此注释
    brand_safety: BrandSafetyMap.UN_SAFE,
    creative_material_mode: creativeType.CUSTOM,
    pricing: '',
    platform: 0, // 不限
    opt_target: 0, // 优化目标
    opt_target_A: 0,
    opt_target_B: 0,
    target_device_version: adgroupIos14Switch.unset, // 是否开启ios14
    isCpxBidCap: false, // 自动出价
    isCpxBidCapList: [false, false], // split-test自动出价
    start_time: '',
    areasData: [],
    pixelToken: '',
    end_time: '',
    contractStartTime: '',
    contractEndTime: '',
    isRFContractTimeAvailable: true, // RF 起止时间是否可用
    rf_timezone: '', // RF 投放时区 形如 Etc/GMT-7
    external_type: 0, // 投放的是app还是website
    adgroupData: {}, // 需要提交给接口的数据，验证通过了，
    adCampaignData: {},
    operatorList: [],
    fakeAdIds: [],
    suggestPrice: {
      suggestPriceOne: 0, // 对于学习阶段的建议出价
      suggestPriceTwo: 0, // 对于第二阶段的建议出价
      suggestPriceDeep: 0, // 对于深度出价的建议出价
    },
    appId4Em: '',
    suggestPriceType: {
      suggestPriceOneType: -1,
      suggestPriceTwoType: -1,
      suggestPriceDeepType: -1,
    },
    dmpInfo: [], // 人群包
    audienceEstimateData: {}, // 受众预估需要的参数
    app_retargeting_install: false,
    dpa_local_audience: '',
    isEstimating: false, // 受众预估正在请求中
    isEstimateFailed: false, // 受众预估请求错误
    isWritable: true,
    ttpUnsupportedArea: [], // ttp 不支持的国家
    cloverUnsupportedArea: [], // clover 不支持的国家
    audienceEstimateScore: 0, // 受众预估档位
    audienceEstimateUserCount: '', // 受众预估人数
    audienceEstimateResult: undefined, // 受众预估结果
    impressionEstimate: undefined, // impression 预估
    impressionEstimateParam: undefined, // impression 预估入参
    isBudgetRecommendVisible: false, // 预算推荐是否可用
    budgetSourceType: BudgetSourceType.manual, // adgroup budget 设置的来源
    budgetRecommendData: undefined, // budget recommend 数据
    budgetRecommendParam: undefined, // budget Recommend 入参
    audienceEstimateDisabledInDpa: false,
    stockEstimate: null, // 库存预估
    stockEstimateKey: '0', // 订单侧返回的 key，用于 RF 回显
    isStockReCalculating: false, // 库存重算中
    isStockOrderCompleted: false, // 库存订单状态
    isStockWidgetAvailable: false, // 库存挂件是否可用
    stockBudgetThreshold: [0, Number.MAX_SAFE_INTEGER], // 根据库存预估曲线，100cpm对应的最低预算值
    stockImpressionThreshold: [0, Number.MAX_SAFE_INTEGER], // 根据库存预估曲线所支持的最小-最大值
    cityMap: [], // 打平的 cityOptions Map
    areasMap: [], // location 所有层级的节点的 [id]: info
    allLocationMap: [], // 全量打平的 location map
    inMarketList: [], // in-market 定向
    inMarketListObj: {}, // in-market 定向 id-item
    inMarketSearchList: [], // in-market 搜索数据
    adInterestArr: [], // 打平的 interestOptions
    adTopicArr: [], // 打平的 topic
    behaviorOptions: [], // 打平的行为定向选项列表
    country: [],
    country_codes_by_split_test_index: [[], []], // 以 split test 的 index 区分存储地域定向的国家码，若未开启定向 split test 则只有第一项
    particle_locations: [],
    availableCountries: [],
    ad_ref_app_id: '', // 选中的app
    isDeepGoalSupportInAppEvent: false, // 深度转化 app 是否支持选择 in-app event
    isDeepEventsModuleShow: false, // 用于install 没有可用事件时，选择深度事件模块展示。 其他场景以deepExternalAction ！== 0 来展示
    appEventList: [], // 事件
    appList: [], // 深度转化需求中新增的的app列表
    editStatisticType: 0, // statistics_type 在edit下的回显字段
    externalActionMap: {}, // app对应的转换事件的statistics_type映射
    externalActions: [], // app对应的转化事件列表，包括浅层和深层
    externalActionsA: [],
    externalActionsB: [],
    externalAction: '', // 包括浅层深度转化目标，pixel的externalAction, 如果有其它地方会赋值这个字段，需要考虑在vi-external-action的data2state里是否添加新的split-test逻辑
    externalActionA: '',
    externalActionB: '',
    pixelId: '',
    brand_safety_partner: 0,
    search_delivery_type: TIKTOK_SEARCH_ADS_SWITCH.DEFAULT, // searchAds开关,0是关闭，1是开启,默认是-1,主要是为了区分从campaign到adgroup层级还是从ad返回到adgroup层级的问题
    pixelEventList: [], // pixel列表
    pixelList: [], // pixel下的event列表,
    pixelInfo: {},
    pixelListLoading: false,
    pixelEventListLoading: false,
    websiteRecommendUrlList: [], // 落地页最近20条推荐url
    appRecommendUrlList: [], // app最近20条推荐url
    open_url: '',
    is_open_url: 0,
    isNewStructure: false,
    budget: '',
    budget_mode: 0,
    externalUrlDomain: '',
    // target 用于 split test 的 tab panel 配置
    ab_test: 0,
    domain: '',
    domainCancelToken: '',
    inAppEvents: [], // in app event的事件，用来判断是否支持优化目标in app event用
    installDeepEvents: [], // install with in app event的event列表
    androidList: [], // 安卓操作系统版本
    iosList: [], // ios操作系统版本
    domainInited: false,
    allLanguagesList: [], // 定向语言选项
    ab_test_status: 0, // 用来判断一个split-test计划是不是已经操作过一件全量， 0:不是split计划 10:是split计划但是没有操作 21:操作过且为获胜组 20:操作过且为失败组
    voStatus: {
      cost_cap_status: VOStatus.NOTSUPPORT,
      roas_status: VOStatus.NOTSUPPORT,
      value_optimizer_status: VOStatus.NOTSUPPORT,
      highest_value_status: VOStatus.NOTSUPPORT,
    },
    targetMultiTabs: [
      {
        title: 'module_target_split_test_card',
        value: 'A',
        isError: false,
      },
      {
        title: 'module_target_split_test_card',
        value: 'B',
        isError: false,
      },
    ],
    biddingMultiTabs: [
      {
        title: 'adgroup_split_bidding_card',
        value: 'A',
        isError: false,
      },
      {
        title: 'adgroup_split_bidding_card',
        value: 'B',
        isError: false,
      },
    ],
    power: 0, // split test 的 power 值
    suggest_budget: 0, // split-test 建议出价
    splitTestVars: [],
    splitTestBudget: [], // 用来存储编辑时候 budget 的值
    splitTestAudienceEstimate: [
      {
        isEstimating: false,
        isEstimateFailed: true,
        audienceEstimateScore: 0,
        isMatchAbTest: false,
        count: 0,
        sample_count: 0,
      },
      {
        isEstimating: false,
        isEstimateFailed: true,
        audienceEstimateScore: 0,
        isMatchAbTest: false,
        count: 0,
        sample_count: 0,
      },
    ],
    platformId: '', // 商品目录 id
    useDraft: false,
    externalActionToken: ['', ''],
    osvToken: '',
    pangleFlowPackArr: [],
    learnParse: false,
    videoCategoryOptions: [],
    flattenedVideoCategoryOptions: [],
    creatorCategoryOptions: [],
    flattenedCreatorCategoryOptions: [],
    deviceModelsList: [],
    alertInfo: {}, // 提示信息，形如 { device: { label: '', content: '' } }
    catalog: null,
    catalogBcId: '0', // 当前修改catalog所属的bcid
    isCatalogAuth: true, // 当前adv是否有Catalog的权限
    adInterestKeywordsInfoMap: {}, // 兴趣关键词描述信息
    adBehaviorHashtag: {}, // 行为 hashtag 定向描述信息
    targetRecommendTraceInfo: null, // 定向推荐埋点追踪信息，如非 null 则需要在广告组创建完成后发送
    adgroupQuota: {
      available_quota: 0,
      using_quota: 0,
      total_quota: getAdgroupDCQuota(),
    },
    splitTestQuota: {
      max: 0,
      available: 0,
      releasing: 0,
      using: 0,
    },
    isAppidInNewQuota: false,
    isOnlySupportTT: false,
    isSupportLowestCost: false,
    isBidStrategyChanged: false,
    isEditClicked: false, // dc strategy是否点击过
    hasCostcap: false, // 当前dc campaign下是否有active的cost cap
    hasLowestCost: false, // 当前dc campaign下是否有active的lowestcost
    pangleSupportCountries: [], // 支持pangle投放的国家地区白名单（用于控制dpa版位）
    copyPixelAwait: false, // copy的时候在pixel组件await了pixel list接口，然后接口返回值还没回来就提交表单pixel_id是空，这个时候需要disabled,
    isOpenBS: false, // 是否打开Brand Safety开关
    ios14_quota_type: IOS14QuotaType.UNOCCUPIED,
    hasRewrittenCopiedStartTime: false, // copy 的广告计划需要覆写投放起始时间，覆写过一次后不需要再次覆写
    appProfilePageType: undefined, // 标识 ios14下，app profile page 开关的状态
    isDpaOrShopCountryOffline: false, // catalog或shop绑定的国家下线
    liveTimezoneList: [], // live ads选择的定向国家对应的时区，用于判断是否处于夏令时
    hasPremiumTopic: false, // 上线文广告中是否有 premium 的 topic
  },
  getters: {
    isAppInstallAmazon(state, getters) {
      return getters.isAppInstall && isModelSoleWhite();
    },
    isTrafficAmazon(state, getters) {
      return getters.isTraffic && isModelSoleWhite();
    },
    isTwoAdgroupDc(state, getters) {
      return getters.isSupportIos14 && isIOS14MultipleTwoWhite() && !isIOS14MultipleFiveWhite();
    },
    isTwoAdgroupUnderDc(state, getters) {
      return getters.isUnderDcHasAdgroup && isIOS14MultipleTwoWhite() && !isIOS14MultipleFiveWhite();
    },
    isUnderDcHasNoAdgroup(state, getters) {
      return getters.isUnderDc && !getters.isUnderDcHasAdgroup && isIOS14MultipleTwoWhite() && !isIOS14MultipleFiveWhite();
    },
    isInstallHasActiveDeepEvent(state) {
      return (state.installDeepEvents.events && state.installDeepEvents.events[0]?.deep_external_action || [])
        .find(item => +item.aeo_availability === eventStatus.ready);
    },
    isMatchExternalUrlDomain(state, getters) {
      return state.externalUrlDomain?.length && getters.eventDomainList.includes(state.externalUrlDomain);
    },
    eventDomainList(state) {
      const pixelEvent = state.pixelInfo?.pixelEvents?.filter(item => +item.id === +state.externalAction);
      const domainList = pixelEvent?.length && pixelEvent[0]?.verified_domain_list || [];
      return domainList;
    },
    isShowPcmDrop(state, getters) {
      return isPcmPhase2White() && !getters.eventDomainList?.length && state.pixelId && state.externalAction;
    },
    isShowIosWebPixelAlert(state) {
      return state.pixelId && state.pixelList?.length && state.pixelList.every(item => !item.has_pcm_config) && isPcmPhase1White();
    },
    isPixelStandardEventList(state, getters) {
      if (isPixelStandardWhite() && (getters.isCreate || getters.isCopy)) {
        return state.pixelEventList.filter(item => !item.deprecated);
      }
      return state.pixelEventList;
    },
    selectedPixelEvent(state) {
      return state.pixelEventList?.find(item => item.id === state.externalAction);
    },
    isShouldEmptyEvent(state, getters) {
      return isPixelStandardWhite() && getters.isCopy && getters.selectedPixelEvent?.deprecated;
    },
    selectedPixelInfo(state) {
      return state.pixelList.find(item => item.id === state.pixelId) || {};
    },
    isCatalogAuth(state, getters) {
      // catalogBcId = 0 就是catalog还没有资产化，就没有权限的问题
      return state.isCatalogAuth || +getters.catalogBcId < 1;
    },
    // getters就像computed
    isUnderDc(state, getters, rootState) {
      return state.adCampaignData.dedicate_type === campaignType.dedicatedCampaign
      && !!state.campaign_id;
    },
    isShowAppIos14AdsMark(state, getters) {
      return state.ad_ref_app_id && ((getters.isDpaSupportIos14 && !getters.isDpaLink) || getters.isAppInstallSupportIos14);
    },
    isShowWebIos14AdsMark(state, getters) {
      return state.pixelId && (getters.isTraffic || getters.isConversion || getters.isDpa) && getters.isWebsite && isPcmPhase1White();
    },
    isFrozenApp(state, getters, rootState) {
      const notAllowedIos14Apps = [AppStatusValue.Probated, AppStatusValue.BlockedConflictAppAccount, AppStatusValue.BlockedUnsupportedMMP];
      // 接口返回前会undefined
      return getters.selectedAppDetail && getters.selectedAppDetail.AccountAppVerifiedState
        ? notAllowedIos14Apps.includes(getters.selectedAppDetail.AccountAppVerifiedState) : false;
    },
    // dc可能没有adgroup此时的app和优化目标不应该disable
    isUnderDcHasAdgroup(state, getters) {
      return getters.isUnderDc && !!state?.adgroupNavList?.length && !!state.adgroupNavList[0].ad_ref_app_id;
    },
    isIOS14App(state, getters) {
      return state.target_device_version === 2;
    },
    isUnderNonDc(state, getters, rootState) {
      return state.adCampaignData.dedicate_type !== campaignType.dedicatedCampaign
      && !!state.campaign_id;
    },
    /** 是否选了行业类型 */
    isSelectedIndustry(state) {
      return !!state.adCampaignData?.industry_types?.length;
    },
    isAdmin(state, getters, rootState) {
      return rootState.account.permissionData?.permission?.is_admin;
    },
    opSysFilter(state, getters) {
      // 不支持的objective  tc = 0， opSysFilter： 0
      // 中间态Non-dc  14.0-   tc =1，  opSysFilter：1
      // Non-dc 14.5-  tc = 0， opSysFilter: 3
      // Dc  14.0+ tc = 2,   opSysFilter: 2
      if (!(getters.isAppInstallSupportIos14 || getters.isConversionSupportIos14 || getters.isDpaSupportIos14)) {
        return 0;
      }
      if (+state.target_device_version === 0) {
        return 3;
      }
      return state.target_device_version;
    },
    operatorOptions(state) {
      const result = Object.keys(state.operatorList).map((v) => {
        const list = state.operatorList[v];
        return list.map(item => ({ ...item, key: item.i18n_value, value: item.id }));
      });
      return _.flatten(result).filter(item => item.in_use);
    },
    isAndriodApp(state, getters) {
      return state.platform === platformEnum.ANDROID && (getters.isAppDownload || getters.isDpaLink);
    },
    isSupportIos14(state) {
      return state.ios14_quota_type === IOS14QuotaType.OCCUPIED;
    },
    isPlatFormIos(state) {
      return state.platform === platformEnum.IOS;
    },
    isEdit(state) {
      return state.action === 'edit' && !!state.ad_id;
    },
    isCopy(state) {
      return state.action === 'copy';
    },
    isCreate(state) {
      return state.action === 'create';
    },
    isDefaultSupportDc(state, getters) {
      return getters.isCreate && getters.isObjectiveSupportDc &&
        !getters.isUnderNonDc && !getters.isCreateAdgroupOutIosMultipleWhite && !(getters.isSplitTestEnabled && !isSplitTestSupportIOS14White());
    },
    isObjectiveSupportDc(state, getters) {
      return (getters.isAppInstallSupportIos14 ||
        (getters.isDpaSupportIos14 && !getters.isDpaLink));
    },
    // 非白在已有的campaign下新建adgroup
    isCreateAdgroupOutIosMultipleWhite(state, getters) {
      return ((getters.isCopy || getters.isCreate) && !!state.campaign_id && !isIOS14MultipleWhite());
    },
    isDpa(state) { // 是不是dpa广告
      return state.objective_type === campaignObjectiveValue.DPA;
    },
    isTraffic(state) {
      return state.objective_type === campaignObjectiveValue.Traffic;
    },
    isConversion(state) {
      return state.objective_type === campaignObjectiveValue.Conversion;
    },
    isSupportBrandDataTrack(state) {
      return isBrandTrackDataWhite() && [campaignObjectiveValue.Reach, campaignObjectiveValue.VideoView,
        campaignObjectiveValue.RF, campaignObjectiveValue.RF_VV, campaignObjectiveValue.RF_TRAFFIC].includes(state.objective_type);
    },
    isRfTrafficSupportPixel(state, getters) {
      return state.objective_type === campaignObjectiveValue.RF_TRAFFIC && isBrandTrackDataWhite() && getters.isWebsite;
    },
    isAppInstall(state) {
      return state.objective_type === campaignObjectiveValue.AppInstall || state.objective_type === campaignObjectiveValue.RF_APPINSTALL;
    },
    isShop(state) { // 是否 Shop monetization广告
      return state.objective_type === campaignObjectiveValue.Shop;
    },
    isShopLive(state, getters) {
      return getters.isShop && state.external_type === Scenario.Live;
    },
    isDpaSupportIos14(state, getters) {
      return getters.isDpa && state.platform === platformEnum.IOS && (getters.isAppDownload || getters.isDpaLink);
    },
    isAppInstallSupportIos14(state, getters) {
      return getters.isAppInstall && state.platform === platformEnum.IOS && getters.isAppDownload;
    },
    isConversionSupportIos14(state, getters) {
      return getters.isConversionApp && state.platform === platformEnum.IOS && getters.isAppDownload;
    },
    isExternalActionSupportNoBid(state, getters, rootState, rootGetters) {
      if (getters.useBiddingSplitTest && getters.isCreate) {
        if (rootState.campaign.activeThirdTabs.itemIndex === 0) {
          return state.externalActionsA.find(item => item.external_action === state.externalActionA)?.is_no_bid_enabled;
        }
        return state.externalActionsB.find(item => item.external_action === state.externalActionB)?.is_no_bid_enabled;
      }
      return state.externalActions.find(item => item.external_action === state.externalAction)?.is_no_bid_enabled;
    },
    // TODO: 修改所有其他各个组件对于content_type的判断，转为使用此getter
    isWebsite(state) {
      return [contentType.website, contentType.ExternalOrDisplay].includes(+state.external_type);
    },
    isAppTypeIOS(state, getters) {
      const isIos = state.platform === platformEnum.IOS && (getters.isAppDownload || getters.isDpaLink);
      return isIos;
    },
    isConversionApp(state, getters) {
      return state.objective_type === campaignObjectiveValue.Conversion && getters.isAppDownload && isAppRetargetWhite();
    },
    isAppDownload(state) {
      return contentType.app.indexOf(+state.external_type) !== -1;
    },
    isDpaLink(state) { // 推广对象为dpalink
      return +state.external_type === contentType.dpaDeeplink;
    },
    /** 标记表单中开启了 split test 开关 */
    isSplitTestEnabled(state) {
      return state.ab_test !== splitTestType.NONE;
    },
    /** @deprecated 是否是 split test，目前 dpa 不使用 split test，isCreate 时需要改用 isSplitTestEnabled 判断 */
    useSplitTest(state, getters, rootState) {
      if (getters.isCreate) {
        // panda 下线 split test 创建，split test 创建统一跳转到重构项目第四层级
        return false;
      }

      if (getters.isEdit) {
        return !!state.ab_test && state.ab_test !== splitTestType.NONE && state.ab_test_status !== 21;
      }

      const { ab_test: abTest, campaign_id: campaignID } = (rootState.route || {}).query || {};

      if (campaignID) {
        return false;
      }
      if (getters.isDpa) {
        return false;
      }
      return !!abTest && +abTest !== splitTestType.NONE;
    },
    /** @deprecated isCreate 时需要改用 isSplitTestEnabled 判断 */
    useTargetSplitTest(state, getters, rootState) {
      if (getters.isEdit) {
        return getters.useSplitTest && state.ab_test === splitTestType.TARGET;
      }
      const { ab_test: abTest } = (rootState.route || {}).query || {};
      return getters.useSplitTest && abTest === splitTestType.TARGET;
    },
    /** @deprecated isCreate 时需要改用 isSplitTestEnabled 判断 */
    useCreativeSplitTest(state, getters, rootState) {
      if (getters.isEdit) {
        return getters.useSplitTest && state.ab_test === splitTestType.CREATIVE;
      }

      const { ab_test: abTest } = (rootState.route || {}).query || {};
      return getters.useSplitTest && abTest === splitTestType.CREATIVE;
    },
    rdAdgroupId(state) {
      return state.rf_ad_id;
    },
    /** @deprecated isCreate 时需要改用 isSplitTestEnabled 判断 */
    useBiddingSplitTest(state, getters, rootState) {
      if (getters.isEdit) {
        return state.ab_test === splitTestType.OPTIMIZE;
      }

      const { ab_test: abTest } = (rootState.route || {}).query || {};
      return +abTest === splitTestType.OPTIMIZE;
    },
    appDetail(state) {
      return appId => state.appList.find(app => `${app.Id}` === `${appId}`);
    },
    bondTrackAppList(state) {
      return state.appList.filter(item => !!item.TrackingUrl?.ClickUrl);
    },
    isEditIos14MiddleMinus(state, getters) {
      // 是否是流量测未拉闸的存量广告
      return getters.isEdit && state.target_device_version === adgroupIos14Switch.ios14Below;
    },
    selectedAppDetail(state, getters) {
      return getters.appDetail(state.ad_ref_app_id);
    },
    // 选中的app是否有三方监测链接
    isSelectedAppHasClickTrackUrl(state, getters) {
      const detail = getters.selectedAppDetail || {};
      const { TrackingUrl = {} } = detail;
      return TrackingUrl?.ClickUrl;
    },
    isSelectedAppHasClickTrackUrlOrSdkS2s(state, getters) {
      try {
        const detail = getters.selectedAppDetail || {};
        const partnerId = _.get(detail, 'Partner.Id', '');
        return SdkS2sAdvertisersIdList.includes(partnerId) || getters.isSelectedAppHasClickTrackUrl;
      } catch (e) {
        return getters.isSelectedAppHasClickTrackUrl;
      }
    },
    isSdkS2s(state, getters) {
      const detail = getters.selectedAppDetail || {};
      const partnerId = _.get(detail, 'Partner.Id', '');
      return SdkS2sAdvertisersIdList.includes(partnerId);
    },
    adgroupKey(state, getters, rootState, rootGetter) {
      return `${rootGetter['campaign/modelKey']}:adgroup`;
    },
    dmpInfo(state) {
      return state.dmpInfo;
    },
    auditStatus(state) {
      return +state.adgroupInfo.audit_status !== adStatusValues.AUDIT;
    },
    isDisabledMoat(state, getters) {
      // 修改的时候只有【新建审核中】可修改
      return getters.isEdit && +state.adgroupInfo.audit_status !== adStatusValues.AUDIT;
    },
    isDisabledDV(state, getters) {
      // 修改的时候只有【新建审核中】可修改
      return getters.isEdit && +state.adgroupInfo.audit_status !== adStatusValues.AUDIT;
    },
    isDisabledIAS(state, getters) {
      // 修改的时候只有【新建审核中】可修改
      return getters.isEdit && +state.adgroupInfo.audit_status !== adStatusValues.AUDIT;
    },
    // targeting 流量包
    pangleFlowPackOrient(state) {
      return state.pangleFlowPackArr.filter(item => item.bind_type === pangleFlowPackConfig.orient.value);
    },
    pangleFlowPackExclude(state) {
      return state.pangleFlowPackArr.filter(item => item.bind_type === pangleFlowPackConfig.exclude.value);
    },
    supportPangleFlow(state) {
      return !!state.pangleFlowPackArr.length;
    },
    deviceModelsList(state) {
      return state.deviceModelsList;
    },
    isMultipleCountrySelected(state) {
      const selectedCountry = state.country || state.adgroupInfo?.country || [];
      return selectedCountry.length > 1;
    },
    countryIdCodeMap(state) {
      const { areasData } = state;
      const idCodeMap = new Map();
      areasData.forEach((area) => {
        idCodeMap.set(area.id, area.code);
      });
      return idCodeMap;
    },
    catalogBcId(state) {
      return state.catalogBcId ?? '0';
    },
    isRF(state) {
      return checkIsRF(state.objective_type);
    },
    /** 商品库的国家 */
    catalogCountry(state) {
      const list = state.catalog?.refer_catalogs?.map(item => item.country) ?? [];
      return [...new Set(list)];
    },
    /** 是否是多国家多语言商品库 */
    isCrossBorderCatalog(state) {
      return state.catalog?.is_multi_country_lang;
    },
    /** 商品库的所有主库 & 子库 */
    referCatalogs(state) {
      return state.catalog?.refer_catalogs ?? [];
    },
    /** 定向地区关联商品库的语言 */
    getCountryCorrespondingLanguage: (state, getters) => countries => [...new Set(
      getters.referCatalogs
        .filter(item => countries.includes(item.country))
        .map(item => item.language),
    )],
    /**
     * 每日最低预算根据白名单进行调整
     * case: 白名单用户自己切到pc创编，然后最低预算是20，编辑的时候允许改为更低的值。
     * https://bytedance.feishu.cn/docs/doccnvEr43Xt3RklzWbaWyBEMJc
     */
    lowestBudget(state, getters, rootState, rootGetters) {
      const isSelfAccount = rootGetters?.['account/isSelfAccount'];
      // 最低预算调整仅限自助用户的编辑场景
      if (!getters.isEdit || !isSelfAccount) {
        return LowestBudget.DEFAULT;
      }
      const enabled = isBudgetReductionEnabled();
      if (!enabled) {
        return LowestBudget.DEFAULT;
      }
      if (state.objective_type === campaignObjectiveValue.Traffic) {
        return LowestBudget.TRAFFIC;
      }
      if (state.objective_type === campaignObjectiveValue.LeadAds) {
        return LowestBudget.LEADGEN;
      }
      if (state.objective_type === campaignObjectiveValue.Engagement) {
        return LowestBudget.ENGAGEMENT;
      }
      return LowestBudget.DEFAULT;
    },
    isShopAdLiveScenario(state, getters) {
      return getters.isShop && state.external_type === Scenario.Live;
    },
    isShopAdVideoScenario(state, getters) {
      return getters.isShop && state.external_type === Scenario.ShortVideo;
    },
    isAppProfilePageOpen(state, getters) {
      return state.appProfilePageType === AppProfilePageType.on;
    },
  },
  mutations: {
    [types.SET_BIDDING_EDIT](state, data) {
      state.isEditClicked = data;
    },
    [types.SET_SUPPORT_LOWEST_COST](state, data) {
      state.isSupportLowestCost = data;
    },
    [types.SET_BIDSTRATEGY](state, data) {
      state.isBidStrategyChanged = data;
    },
    [types.SET_HAS_COSTCAP](state, data) {
      state.hasCostcap = data;
    },
    [types.SET_HAS_LOWESTCOST](state, data) {
      state.hasLowestCost = data;
    },
    [types.SET_ADGROUP_DOMAIN](state, data) {
      state.domain = data;
    },
    [types.SET_DOMAIN_INITED](state, data) {
      state.domainInited = data;
    },
    [types.SET_COPY_PIXEL_AWAIT](state, data) {
      state.copyPixelAwait = data;
    },
    [types.SET_ADGROUP_EXTERNAL_URL_DOMAIN](state, data) {
      state.externalUrlDomain = data;
    },
    [types.SET_IOS_LIST](state, data) {
      state.iosList = data;
    },
    [types.SET_EXTERNALACTION_TOKEN](state, val) {
      state.externalActionToken[val.index] = val.data;
    },
    [types.SET_ANDROID_LIST](state, data) {
      state.androidList = data;
    },
    [types.SET_ALL_LANGUAGES_LIST](state, data) {
      state.allLanguagesList = data;
    },
    [types.SET_PIXEL_LIST_LOADING](state, data) {
      state.pixelListLoading = data;
    },
    [types.SET_SUGGEST_PRICE](state, data) {
      state.suggestPrice = {
        ...state.suggestPrice,
        ...data,
      };
    },
    [types.SET_SUGGEST_PRICE_TYPE](state, data) {
      state.suggestPriceType = {
        ...state.suggestPriceType,
        ...data,
      };
    },
    [types.SET_START_TIME](state, data) {
      state.start_time = data;
    },
    [types.SET_END_TIME](state, data) {
      state.end_time = data;
    },
    [types.SET_STRUCTURE](state, data) {
      state.isNewStructure = data;
    },
    [types.SET_IS_ENABLE_IOS14](state, data) {
      state.target_device_version = data;
    },
    [types.SET_WEB_URL_LIST](state, data) {
      state.websiteRecommendUrlList = data;
    },
    [types.SET_APP_ID_4_EM](state, data) {
      state.appId4Em = data;
    },
    [types.SET_APP_URL_LIST](state, data) {
      state.appRecommendUrlList = data;
    },
    [types.SET_PIXEL_EVENT_LIST_LOADING](state, data) {
      state.pixelEventListLoading = data;
    },
    [types.SET_PIXEL_EVENT_LIST](state, data) {
      state.pixelEventList = data;
    },
    [types.SET_PIXEL_LIST](state, data) {
      state.pixelList = data;
    },
    [types.SET_PIXEL_INFO](state, data) {
      state.pixelInfo = data;
    },
    [types.SET_LOADING_STATE](state, { status }) {
      state.loading = status;
    },
    [types.SET_CONTRACT_START_TIME](state, data) {
      state.contractStartTime = data;
    },
    [types.SET_CONTRACT_END_TIME](state, data) {
      state.contractEndTime = data;
    },
    [types.SET_RF_CONTRACT_TIME_AVAILABLE](state, data) {
      state.isRFContractTimeAvailable = data;
    },
    [types.SET_RF_TIMEZONE](state, data) {
      state.rf_timezone = data;
    },
    [types.SET_LIVE_TIMEZONE_FOR_DST](state, data) {
      state.liveTimezoneList = data;
    },
    [types.SET_CONTRACT_END_TIME](state, data) {
      state.contractEndTime = data;
    },
    [types.SET_IN_APP_EVENTS](state, data) {
      state.inAppEvents = data;
    },
    [types.SET_INSTALL_WITH_IN_APP_EVENTS](state, data) {
      state.installDeepEvents = data;
    },
    [types.SET_APP_RETARGETING_INSTALL](state, data) {
      state.app_retargeting_install = data;
    },
    [types.SET_DPA_LOCAL_AUDIENCE](state, data) {
      state.dpa_local_audience = data;
    },
    [types.SET_EXTERNAL_ACTION](state, data) {
      state.externalAction = data;
    },
    [types.SET_IS_SUPPORT_IN_APP_EVENT](state, data) {
      state.isDeepGoalSupportInAppEvent = data;
    },
    [types.SET_IS_DEEP_EVENT_MODULE_SHOW](state, data) {
      state.isDeepEventsModuleShow = data;
    },
    [types.SET_EXTERNAL_ACTIONA](state, data) {
      state.externalActionA = data;
    },
    [types.SET_EXTERNAL_ACTIONB](state, data) {
      state.externalActionB = data;
    },
    [types.SET_OPEN_URL](state, data) {
      state.open_url = data;
    },
    [types.SET_IS_OPEN_URL](state, data) {
      state.is_open_url = data;
    },
    [types.SET_EXTERNAL_ACTION_MAP](state, data) {
      state.externalActionMap = data;
    },
    [types.SET_PIXEL_ID](state, data) {
      state.pixelId = data;
    },
    [types.SET_FAKE_ADIDS](state, data = {}) {
      state.fakeAdIds = data; // buildStone需要的东西
    },
    [types.SET_TARGET_MULTI_TABS](state, data = []) {
      state.targetMultiTabs = data;
    },
    [types.SET_BIDDING_MULTI_TABS](state, data = []) {
      state.biddingMultiTabs = data;
    },
    [types.SET_ADGROUP_ACTIVE_TAB](state, tab) {
      state.activeTab = `${tab}`;
    },
    [types.SET_ADGROUP_ACTION](state, cmd) {
      state.action = cmd;
    },
    [types.GET_CAMPAIGN_NAV_LIST](state, data) {
      state.campaignNavList = data;
    },
    [types.GET_AD_NAV_LIST](state, data) {
      state.adgroupNavList = data.filter(item => !item.ad_test_id);
    },
    [types.GET_AD_GROUP_INFO](state, data) {
      state.adgroupInfo = data;
    },
    [types.SET_AD_GROUP_DATA](state, data = {}) {
      state.adgroupData = data;
    },
    [types.SET_AD_GROUP_ID](state, adId) {
      state.ad_id = `${adId}`;
    },
    [types.SET_RF_AD_GROUP_ID](state, id) {
      state.rf_ad_id = `${id}`;
    },
    [types.SET_CAMPAIGN_OBJECTIVE_TYPE](state, type) {
      state.objective_type = +type;
    },
    [types.SET_CAMPAIGN_ID](state, ID) {
      state.campaign_id = `${ID}`;
    },
    [types.SET_INVENTORY_FLOW](state, flow) {
      if (
        (Array.isArray(flow) && _.isEqual(flow, state.inventory_flow)) ||
        (!Array.isArray(flow) && _.isEqual([flow], state.inventory_flow))
      ) {
        return;
      }

      if (Array.isArray(flow)) {
        state.inventory_flow = flow;
      } else {
        state.inventory_flow = [flow];
      }
    },
    [types.SET_CONVERSION_CHECKED](state, checked) { // TODO: pixel全量上线后此逻辑需要下掉，所有改动处均有此注释
      state.conversion_checked = checked;
    },
    [types.SET_INVENTORY_FLOW_TYPE](state, val) {
      state.inventory_flow_type = val;
    },
    [types.SET_BRAND_SAFETY](state, val) {
      state.brand_safety = val;
    },
    [types.SET_BRAND_SAFETY_PARTNER](state, val) {
      state.brand_safety_partner = val;
    },
    // [types.SET_CONTENT_TYPE](state, val) {
    //   state.external_type = +val;
    // },
    [types.SET_EXTERNAL_TYPE](state, val) {
      state.external_type = +val;
    },
    [types.SET_ADGROUP_OPT_TARGET](state, val) {
      state.opt_target = +val;
    },
    [types.SET_ADGROUP_OPT_TARGET_A](state, val) {
      state.opt_target_A = val;
    },
    [types.SET_ADGROUP_OPT_TARGET_B](state, val) {
      state.opt_target_B = val;
    },
    [types.SET_CPX_BID_CAP](state, val) {
      state.isCpxBidCap = val;
    },
    [types.SET_CPX_BID_CAP_LIST](state, val) {
      state.isCpxBidCapList[val.index] = val.value;
    },
    [types.SET_ADGROUP_PRICING](state, val) {
      state.pricing = val;
    },
    [types.SET_AD_CLASSIFY](state, classify) {
      state.classify = classify;
    },
    [types.SET_AD_PLAT_FORM](state, platform) {
      if (!platform && platform !== platformEnum.ALL) {
        return;
      }
      state.platform = +platform;
    },
    [types.SET_ADGROUP_COPY_NUM](state, num = 1) {
      state.copyNumber = num;
    },
    [types.SET_ADGROUP_BATCH_INFO](state, arr = []) {
      state.batchInfo = arr;
    },
    [types.SET_ADGROUP_BATCH_VISIBLE](state, v) {
      state.batchVisible = v;
    },
    [types.SET_CREATIVE_MATERIAL_MODE](state, v) {
      state.creative_material_mode = v;
    },
    [types.SET_ADGROUP_DATA_FLAG](state, flag) {
      if (state.adgroupData && Object.keys(state.adgroupData).length > 0) {
        state.adgroupData.adgroupSuccess = !!flag;
      }
    },
    [types.SET_AD_CAMPAIGN_DATA](state, data = {}) {
      state.adCampaignData = data;
    },
    [types.GET_OPERATOR_LIST](state, data = {}) {
      state.operatorList = data;
    },
    [types.SET_AUDIENCE_ESTIMATE_TTP](state, data = false) {
      state.ttpUnsupportedArea = data;
    },
    [types.SET_AUDIENCE_ESTIMATE_CLOVER](state, data = []) {
      state.cloverUnsupportedArea = data;
    },
    [types.SET_IS_WRITABLE](state, data = true) {
      state.isWritable = data;
    },
    [types.SET_AUDIENCE_ESTIMATE_SCORE](state, v) {
      state.audienceEstimateScore = v;
    },
    [types.SET_IMPRESSION_ESTIMATE](state, data) {
      state.impressionEstimate = data;
    },
    [types.SET_IS_BUDGET_RECOMMEND_VISIBLE](state, data) {
      state.isBudgetRecommendVisible = data;
    },
    [types.SET_BUDGET_SOURCE_TYPE](state, data) {
      state.budgetSourceType = data;
    },
    [types.SET_IMPRESSION_ESTIMATE_PARAM](state, data) {
      state.impressionEstimateParam = data;
    },
    [types.SET_BUDGET_RECOMMEND_DATA](state, data) {
      state.budgetRecommendData = data;
    },
    [types.SET_BUDGET_RECOMMEND_PARAM](state, data) {
      state.budgetRecommendParam = data;
    },
    [types.SET_AUDIENCE_ESTIMATE_USER_COUNT](state, v) {
      state.audienceEstimateUserCount = v;
    },
    [types.SET_AUDIENCE_ESTIMATE_RESULT](state, data) {
      state.audienceEstimateResult = data;
    },
    [types.SET_AUDIENCE_ESTIMATE_DATA](state, data) {
      state.audienceEstimateData = { ...data };
    },
    [types.SET_AUDIENCE_LOADING](state, isLoading) {
      state.isEstimating = isLoading;
    },
    // dpa重定向app直投pangle时不支持受众预估，增加一个state避免对愿逻辑产生影响，方便后续删除
    [types.SET_AUDIENCE_DISABLED_IN_DPA](state, audienceEstimateDisabledInDpa = false) {
      state.audienceEstimateDisabledInDpa = audienceEstimateDisabledInDpa;
    },
    [types.SET_OSV_TOKEN](state, data) {
      state.osvToken = data;
    },
    [types.SET_PIXEL_TOKEN](state, data) {
      state.pixelToken = data;
    },
    [types.SET_AUDIENCE_FAILED](state, isFailed) {
      state.isEstimateFailed = isFailed;
    },
    [types.SET_STOCK_WIDGET_AVAILABLE](state, data) {
      state.isStockWidgetAvailable = data;
    },
    [types.SET_STOCK_ESTIMATE](state, data) {
      state.stockEstimate = { ...data };
    },
    [types.SET_STOCK_ESTIMATE_KEY](state, data) {
      state.stockEstimateKey = data;
    },
    [types.SET_STOCK_RECALCULATING](state, data) {
      state.isStockReCalculating = data;
    },
    [types.SET_STOCK_ORDER_COMPLETED](state, data) {
      state.isStockOrderCompleted = data;
    },
    [types.SET_STOCK_BUDGET_THRESHOLD](state, data) {
      state.stockBudgetThreshold = { ...data };
    },
    [types.SET_CAMPAIGN_QUOTA](state, data) {
      state.campaignQuota = { ...data };
    },
    [types.SET_ADGROUP_QUOTA](state, data) {
      state.adgroupQuota = { ...data };
    },
    [types.SET_SPLIT_TEST_QUOTA](state, data) {
      state.splitTestQuota = { ...data };
    },
    [types.SET_APP_ID_IN_NEW_QUOTA](state, isAppidInNewQuota) {
      state.isAppidInNewQuota = isAppidInNewQuota;
    },
    [types.SET_IS_ONLY_SUPPORT_TT](state, isOnlySupportTT) {
      state.isOnlySupportTT = isOnlySupportTT;
    },
    [types.SET_STOCK_IMPRESSION_THRESHOLD](state, data) {
      state.stockImpressionThreshold = { ...data };
    },
    [types.SET_CITY_MAP](state, data) {
      state.cityMap = data;
    },
    [types.SET_AREAS_MAP](state, data) {
      state.areasMap = data;
    },
    [types.SET_ALL_LOCATION_MAP](state, data) {
      state.allLocationMap = data;
    },
    [types.SET_AD_INTEREST_MAP](state, data) {
      state.adInterestArr = data;
    },
    [types.SET_AD_TOPIC_MAP](state, data) {
      state.adTopicArr = data;
    },
    [types.SET_IN_MARKET_LIST](state, data) {
      state.inMarketList = data;
    },
    [types.SET_IN_MARKET_LIST_OBJ](state, data) {
      state.inMarketListObj = data;
    },
    [types.SET_IN_MARKET_SEARCH_LIST](state, data) {
      state.inMarketSearchList = data;
    },
    [types.SET_AD_INTEREST_KEYWORDS_INFO_BY_ID](state, { id, lang, data }) {
      Vue.set(state.adInterestKeywordsInfoMap, `${id}-${lang}`, data);
    },
    [types.CLEAR_AD_INTEREST_KEYWORDS_INFO_MAP](state) {
      state.adInterestKeywordsInfoMap = {};
    },
    [types.SET_AD_BEHAVIOR_HASHTAG_INFO](state, { id, data }) {
      Vue.set(state.adBehaviorHashtag, id, data);
    },
    [types.CLEAR_AD_BEHAVIOR_HASHTAG_INFO](state) {
      state.adBehaviorHashtag = {};
    },
    [types.SET_DMP_INFO](state, list) {
      state.dmpInfo = list;
    },
    [types.SET_ADGROUP_COUNTRY](state, data) {
      state.country = data && data.map(item => +item) || [];
    },
    [types.SET_ADGROUP_COUNTRY_CODES_BY_SPLIT_TEST_INDEX](state, { index = 0, data }) {
      state.country_codes_by_split_test_index.splice(index, 1, data.filter(code => typeof code === 'string'));
    },
    [types.SET_PARTICLE_LOCATIONS](state, { index = 0, data }) {
      state.particle_locations[index] = data;
    },
    [types.SET_USE_DRAFT](state, val) {
      state.useDraft = val;
    },
    [types.SET_AREAS_LIST](state, val) {
      state.areasData = val;
    },
    [types.SET_AVAILABLE_COUNTRIES](state, data) {
      state.availableCountries = data;
    },
    [types.SET_APP_ID](state, data) {
      state.ad_ref_app_id = data;
    },
    [types.SET_APP_LIST](state, data) {
      state.appList = data;
    },
    [types.SET_APP_EVENT_LIST](state, list) {
      state.appEventList = list;
    },
    [types.SET_EXTERNAL_ACTIONS](state, data) {
      state.externalActions = data;
    },
    [types.SET_EXTERNAL_ACTIONS_A](state, data) {
      state.externalActionsA = data;
    },
    [types.SET_EXTERNAL_ACTIONS_B](state, data) {
      state.externalActionsB = data;
    },

    [types.SET_BUDGET](state, data) {
      state.budget = data.budget;
      state.budget_mode = data.budget_mode;
    },
    [types.SET_SPLIT_TEST](state, data = 0) {
      state.ab_test = data;
    },
    [types.SET_SPLIT_TEST_VAR](state, data) {
      state.splitTestVars = data;
    },
    // 设置对应 split test index 的 adgroup 的定向推荐埋点追踪器
    [types.SET_TARGET_RECOMMEND_TRACE_INFO](state, data) {
      state.targetRecommendTraceInfo = data;
    },
    [types.CLEAR_TARGET_RECOMMEND_TRACE_INFO](state) {
      state.targetRecommendTraceInfo = null;
    },
    [types.SET_POWER](state, data) {
      state.power = _.floor(data, 3);
    },
    [types.SET_SUGGEST_BUDGET](state, data) {
      state.suggest_budget = _.floor(data, 3);
    },
    [types.SET_SP_BUDGET](state, data) {
      state.splitTestBudget = data;
    },
    [types.SET_SP_ESTIMATE_DATA](state, { index, data }) {
      const newEstimate = [
        ...state.splitTestAudienceEstimate,
      ];
      newEstimate[index] = data;

      state.splitTestAudienceEstimate = newEstimate;
    },
    [types.SET_BEHAVIOR_OPTIONS](state, data = []) {
      state.behaviorOptions = data;
    },
    [types.SET_CATALOG](state, catalog = null) {
      state.catalog = catalog;
      state.platformId = catalog ? catalog.platformId : '';
    },
    [types.SET_CATALOG_BC_ID](state, bcId) {
      state.catalogBcId = bcId || '0';
    },
    [types.SET_CATALOG_AUTHORIZED](state, isCatalogAuth = true) {
      state.isCatalogAuth = isCatalogAuth;
    },
    [types.SET_EDIT_STATISTIC_TYPE](state, data = []) {
      state.editStatisticType = data;
    },
    [types.SET_AD_TEST_STATUS](state, data = 0) {
      state.ab_test_status = data;
    },
    [types.SET_PANGLE_FLOW_PKG](state, data = []) {
      state.pangleFlowPackArr = data;
    },
    [types.SET_LEARN_PARSE](state, data = false) {
      state.learnParse = data;
    },
    [types.SET_INITIALIZED](state, data = false) {
      state.initialized = data;
    },
    [types.SET_VIDEO_CATEGORY_OPTIONS](state, data = []) {
      categoryHandler(data);
      state.videoCategoryOptions = data;
    },
    [types.SET_FLATTENED_VIDEO_CATEGORY_OPTIONS](state, data = []) {
      state.flattenedVideoCategoryOptions = data;
    },
    [types.SET_CREATOR_CATEGORY_OPTIONS](state, data = []) {
      categoryHandler(data);
      state.creatorCategoryOptions = data;
    },
    [types.SET_FLATTENED_CREATOR_CATEGORY_OPTIONS](state, data = []) {
      state.flattenedCreatorCategoryOptions = data;
    },
    [types.SET_DEVICE_MODEL_LIST](state, data = []) {
      state.deviceModelsList = data;
    },
    [types.ADD_ALERT_INFO](state, { key, info }) {
      if (!info) return;
      state.alertInfo = { ...state.alertInfo, [key]: info };
    },
    [types.CLEAR_ALERT_INFO](state, { keys = [] } = {}) {
      if (keys.length) {
        const alertInfo = {};
        Object.keys(state.alertInfo).filter(key => !keys.includes(key)).forEach((key) => {
          alertInfo[key] = state.alertInfo[key];
        });
        state.alertInfo = alertInfo;
      } else {
        state.alertInfo = {};
      }
    },
    [types.SET_PANGLE_SUPPORT_COUNTRIES](state, pangleSupportCountries = []) {
      if (pangleSupportCountries.length) {
        state.pangleSupportCountries = pangleSupportCountries;
      }
    },
    [types.SET_IS_OPENBS](state, open) {
      state.isOpenBS = open;
    },
    [types.SET_IOS14_QUOTATYPE](state, type) {
      state.ios14_quota_type = type;
    },
    [types.SET_SEARCH_DELIVERY_TYPE](state, val) {
      state.search_delivery_type = val;
    },
    [types.SET_DOMAIN_TOKEN](state, token) {
      state.domainCancelToken = token;
    },
    [types.SET_HAS_REWRITTEN_COPIED_START_TIME](state, val) {
      state.hasRewrittenCopiedStartTime = val;
    },
    [types.SET_APP_PROFILE_PAGE_TYPE](state, val) {
      state.appProfilePageType = val;
    },
    [types.SET_DPA_OR_SHOP_COUNTRY_OFFLINE](state, val) {
      state.isDpaOrShopCountryOffline = val;
    },
    setVOStatus(state, val) {
      state.voStatus = val;
    },
    [types.SET_HAS_PREMIUM_TOPIC](state, val) {
      state.hasPremiumTopic = val;
    },
  },
  actions: {
    // 获取url的全局参数
    fillQueryParams({ commit }, params = {}) {
      commit(types.SET_ADGROUP_ACTION, params.act || 'create');
      commit(types.SET_CAMPAIGN_ID, params.campaign_id || '');
      commit(types.SET_AD_GROUP_ID, params.ad_id || '');
      commit(types.SET_CAMPAIGN_OBJECTIVE_TYPE, params.objective_type || '');
    },
    async getDomain({ state, commit, getters }, url) {
      if (state.domainCancelToken) {
        state.domainCancelToken.cancel();
      }
      const cancelToken = request.axios.CancelToken;
      const source = cancelToken.source();
      commit(types.SET_DOMAIN_TOKEN, source);
      try {
        const data = await service.getExternalUrlDomain({
          external_url: url,
        }, source.token);
        commit(types.SET_ADGROUP_EXTERNAL_URL_DOMAIN, data.domain);
        if (getters.eventDomainList.length && getters.eventDomainList.includes(data.domain)) {
          commit(types.SET_ADGROUP_DOMAIN, data.domain);
        }
        return data.domain || '';
      } catch (err) {
        captureError(err);
      }
    },
    async setCampaignID({ commit }, ID) {
      commit(types.SET_CAMPAIGN_ID, ID);
      return ID;
    },
    // 获取已经存在的广告组
    async getCampaignNavList({ commit }, params) {
      let data = [];
      try {
        data = await service.getCampaignNavList(params);
      } catch (err) {
        captureError(err);
      }
      commit(types.GET_CAMPAIGN_NAV_LIST, data);
      return data;
    },
    async getOperatorList({ commit }) {
      let data = [];
      try {
        data = await service.getOperatorList();
      } catch (err) {
        captureError(err);
      }
      commit(types.GET_OPERATOR_LIST, data);
      return data;
    },

    // 获取已经存在的广告组
    async getAdCampaignData(store, params) {
      const { commit, rootState } = store;
      const { campaign_id } = params;
      let data = {};
      try {
        if (campaign_id) {
          data = await service.getCampaignModifyTime({ campaign_id });
        } else {
          data = rootState.campaign.adcampaign.campaignSaved || {};
        }
        commit(types.SET_AD_CAMPAIGN_DATA, data);
      } catch (err) {
        captureError(err);
      }
      return data;
    },
    async loadAreasData({ commit }, param) {
      let areas = [];
      try {
        areas = await fetchAreasData(param);
      } catch (err) {
        captureError(err);
      }
      commit(types.SET_AREAS_LIST, areas);
      return areas;
    },

    // 获取已经存在的广告组
    async getAdgroupNavList({ commit }, { campaign_id }) {
      let data = [];
      try {
        if (campaign_id) {
          data = await service.getAdgroupNavList({ campaign_id });
        }
      } catch (err) {
        captureError(err);
      }
      commit(types.GET_AD_NAV_LIST, data);
      return data;
    },

    // 获取Ad信息,回填表单
    async getAdgroupInfo(store, options) {
      const { commit } = store;
      let data = {};
      try {
        if (!options.isCreative) {
          commit(types.SET_LOADING_STATE, { status: true });
        }
        delete options.isCreative;
        const { isInCopyCreative, ...params } = options;
        if (!params.ad_id) {
          return;
        }
        ({ data } = await service.getAdgroupInfo(params));
        const { objective_type } = data || {};
        const isDpa = +objective_type === +campaignObjectiveValue.DPA;
        const isShop = +data?.base_info?.objective_type === +campaignObjectiveValue.Shop;
        // 如果是创意复制的逻辑里，强制将创意类型变成普通创意；【但不包含以下类型的创意】
        // 1. DPA创意
        const shouldRewriteMaterialMode = isInCopyCreative && !isDpa;
        const adgroupInfo = {
          ad_id: params.ad_id,
          ...data.base_info,
          // 如果是创意复制的逻辑里，强制将创意类型变成普通创意
          ...(shouldRewriteMaterialMode ? { creative_material_mode: creativeType.CUSTOM } : null),
        };
        commit(types.GET_AD_GROUP_INFO, adgroupInfo);
        const { catalogBcId } = store.state;
        const hadSelectCatalog = catalogBcId && catalogBcId !== '0';
        if (!hadSelectCatalog) {
          // 如果已经设置过则不需要初始化避免被覆盖，只在编辑复制到已有计划下需要初始化
          commit(types.SET_CATALOG_BC_ID, isShop ? adgroupInfo.shop_authorized_bc : adgroupInfo.catalog_authorized_bc);
        }
        commit(types.SET_LOADING_STATE, { status: false });
      } catch (err) {
        captureError(err);
        commit(types.SET_LOADING_STATE, { status: false });
      }
      return data;
    },
    // 获取Ad信息,回填表单
    async getAdgroupInfoByDraftGetForSimplifiedSmb(store, options) {
      const { commit } = store;
      let data = {};
      try {
        commit(types.SET_LOADING_STATE, { status: true });
        delete options.isCreative;
        const { ...params } = options;
        const { draft_json = {} } = await getUserDraftChecked(params);
        data = draft_json;
        const adgroupInfo = {
          ad_id: params.ad_id,
          ...draft_json.base_info || {},
          struct_version: 1,
        };
        commit(types.SET_AD_GROUP_DATA, adgroupInfo);
        commit(types.GET_AD_GROUP_INFO, adgroupInfo);
        commit(types.SET_LOADING_STATE, { status: false });
      } catch (err) {
        captureError(err);
        commit(types.SET_LOADING_STATE, { status: false });
      }
      return data;
    },

    // 获取复制的Ad信息,回填表单
    async getCopyAdgroupInfo(store, params) {
      const { commit } = store;
      let data = {};
      try {
        commit(types.SET_LOADING_STATE, { status: true });
        ({ data } = await service.getCopyAdgroupInfo(params));
        // if (resp && resp.body) {
        //   data = resp.body || {};
        // }
        commit(types.GET_AD_GROUP_INFO, {
          ad_id: params.ad_id,
          ...data,
        });
        commit(types.SET_ADGROUP_COUNTRY, data && data.country || []);
        commit(types.SET_LOADING_STATE, { status: false });
      } catch (err) {
        captureError(err);
        commit(types.SET_LOADING_STATE, { status: false });
      }
      return data;
    },

    // 接口校验创建计划
    async checkAdgroup(store, postData) {
      let data = {};
      const { commit } = store;
      try {
        commit(types.SET_LOADING_STATE, { status: true });
        data = await service.checkAdgroup(postData);
        commit(types.SET_LOADING_STATE, { status: false });
      } catch (err) {
        commit(types.SET_LOADING_STATE, { status: false });
        data = { ...err };
        captureError(err);
      }
      return data;
    },
    setLocalAdgroup(store, formData) {
      const { getters } = store;
      try {
        const adgroupKey = getters.adgroupKey || '';
        return service.setLocalStore(adgroupKey, formData);
      } catch (err) {
        captureError(err);
      }
    },

    // 获取创意审核建议
    getAdGroupSuggestions(store, id) {
      return request.get(apis.ad.suggestions, { ad_id: id });
    },
    async getCampaignQuota({ commit }, data) {
      let quota = {};
      try {
        quota = await service.getCampaignQuota(data);
      } catch (err) {
        captureError(err);
      }
      commit(types.SET_CAMPAIGN_QUOTA, quota?.campaign_quota);
      commit(types.SET_ADGROUP_QUOTA, quota?.ad_group_quota);
      commit(types.SET_SPLIT_TEST_QUOTA, quota?.split_test);
      return quota;
    },
    async getIos14QuotaInfo({ commit, dispatch }, params) {
      const { app_id, campaign_id = '' } = params;
      const { has } = await service.getAppIdIsNewQuotaProcess({
        app_id,
      });
      commit(types.SET_APP_ID_IN_NEW_QUOTA, has);
      if (has) {
        const [campaignQuota, adgroupQuotaInfo] = await Promise.all([
          service.useIOS14QuotaApiForCampaign({ app_id, campaign_id }),
          service.useIOS14QuotaApiForAdgroup({ campaign_id }),
        ]);
        commit(types.SET_CAMPAIGN_QUOTA, campaignQuota);
        commit(types.SET_ADGROUP_QUOTA, adgroupQuotaInfo);
      } else {
        dispatch('getCampaignQuota', params);
      }
    },
    getLocalAdgroup(store) {
      const { getters } = store;
      let data = {};
      try {
        const adgroupKey = getters.adgroupKey || '';
        data = service.getLocalStore(adgroupKey);
      } catch (err) {
        captureError(err);
      }
      return data;
    },
    // TODO: 这个函数扩展性极其之低，每次在state中新增了字段，都要在这里手动添加对应的重置逻辑。。。。。
    async clearAdgroupAllData({ getters, commit }) {
      try {
        const adgroupKey = getters.adgroupKey || '';
        await service.removeLocalStore(adgroupKey);
        commit(types.SET_AD_GROUP_DATA, {});
        commit(types.SET_AD_CAMPAIGN_DATA, {});
        commit(types.SET_ADGROUP_ACTION, 'create');
        commit(types.SET_CAMPAIGN_ID, '');
        commit(types.SET_AD_GROUP_ID, '');
        commit(types.SET_IS_ENABLE_IOS14, adgroupIos14Switch.unset);
        commit(types.SET_CAMPAIGN_OBJECTIVE_TYPE, '');
        commit(types.SET_INVENTORY_FLOW, []);
        commit(types.SET_CONVERSION_CHECKED, false); // TODO: pixel全量上线后此逻辑需要下掉，所有改动处均有此注释
        commit(types.SET_CREATIVE_MATERIAL_MODE, creativeType.CUSTOM);
        commit(types.SET_ADGROUP_COPY_NUM, 1);
        commit(types.SET_ADGROUP_BATCH_INFO, []);
        commit(types.GET_AD_GROUP_INFO, {});
        commit(types.SET_AD_CLASSIFY, 1);
        commit(types.GET_CAMPAIGN_NAV_LIST, []);
        commit(types.GET_AD_NAV_LIST, []);
        commit(types.SET_ADGROUP_BATCH_INFO, []);
        commit(types.SET_ADGROUP_PRICING, '');
        commit(types.SET_AD_PLAT_FORM, 0);
        commit(types.SET_ADGROUP_OPT_TARGET, 0);
        commit(types.SET_CPX_BID_CAP, false);
        commit(types.SET_FAKE_ADIDS, []);
        commit(types.SET_ADGROUP_EXTERNAL_URL_DOMAIN, '');
        commit(types.SET_STOCK_BUDGET_THRESHOLD, [-Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER]);
        commit(types.SET_STOCK_IMPRESSION_THRESHOLD, [-Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER]);
        commit(types.SET_STOCK_ESTIMATE_KEY, '');
        commit(types.SET_STOCK_WIDGET_AVAILABLE, false);
        commit(types.SET_APP_ID, '');
        commit(types.SET_APP_LIST, []);
        commit(types.SET_APP_EVENT_LIST, []);
        commit(types.SET_EXTERNAL_ACTIONS, []);
        commit(types.SET_EXTERNAL_ACTION, 0);
        commit(types.SET_EXTERNAL_ACTIONA, 0);
        commit(types.SET_EXTERNAL_ACTIONB, 0);
        commit(types.SET_PIXEL_ID, '');
        commit(types.SET_EXTERNAL_TYPE, 0);
        commit(types.SET_PIXEL_EVENT_LIST, []);
        commit(types.SET_PIXEL_LIST, []);
        commit(types.SET_PIXEL_INFO, {});
        commit(types.SET_WEB_URL_LIST, []);
        commit(types.SET_APP_URL_LIST, []);
        commit(types.SET_OPEN_URL, '');
        commit(types.SET_IS_OPEN_URL, 0);
        commit(types.SET_SUGGEST_PRICE, 0);
        commit(types.SET_BEHAVIOR_OPTIONS, []);
        commit(types.SET_SUGGEST_PRICE_TYPE, '');
        commit(types.SET_DEVICE_MODEL_LIST, []);
        commit(types.CLEAR_ALERT_INFO);
        commit(types.SET_INITIALIZED, false);
        commit(types.SET_ADGROUP_COUNTRY_CODES_BY_SPLIT_TEST_INDEX, { index: 0, data: [] });
        commit(types.SET_ADGROUP_COUNTRY_CODES_BY_SPLIT_TEST_INDEX, { index: 1, data: [] });
        commit(types.CLEAR_AD_INTEREST_KEYWORDS_INFO_MAP);
        commit(types.CLEAR_AD_BEHAVIOR_HASHTAG_INFO);
        commit(types.CLEAR_TARGET_RECOMMEND_TRACE_INFO);
        commit(types.SET_CATALOG_BC_ID, '0');
        commit(types.SET_CATALOG);
        commit(types.SET_HAS_REWRITTEN_COPIED_START_TIME, false);
        commit(`shop/${types.RESET_SHOP_STATE}`, null, { root: true });
      } catch (err) {
        captureError(err);
      }
      return Promise.resolve(true);
    },
    removeSplitTestVuex(store) {
      const { commit, state } = store;
      commit(types.SET_SPLIT_TEST_VAR, []);
      commit(types.SET_SP_BUDGET, []);
      commit(types.SET_AD_TEST_STATUS, 0);
      state.targetMultiTabs.forEach((item) => {
        commit(types.SET_SP_ESTIMATE_DATA, {
          isEstimating: false,
          isEstimateFailed: true,
          audienceEstimateScore: 0,
          isMatchAbTest: false,
          sample_count: 0,
          count: 0,
        });
      });
    },
    async removeLocalAdgroup(store) {
      const { getters, commit, state } = store;
      try {
        // 清空草稿的函数不能清空vuex,清空vuex会导致复制回退一些getters计算错误
        const adgroupKey = getters.adgroupKey || '';
        await service.removeLocalStore(adgroupKey);
        commit(types.SET_APP_ID, '');
        commit(types.SET_EXTERNAL_ACTION, '');
        commit(types.SET_AD_PLAT_FORM, 0);

        // 清除 Split test 中的一些变量
        commit(types.SET_SPLIT_TEST_VAR, []);
        commit(types.SET_SP_BUDGET, []);
        commit(types.SET_AD_TEST_STATUS, 0);
        commit(types.SET_IS_ENABLE_IOS14, adgroupIos14Switch.unset);
        state.targetMultiTabs.forEach((item) => {
          commit(types.SET_SP_ESTIMATE_DATA, {
            isEstimating: false,
            isEstimateFailed: true,
            audienceEstimateScore: 0,
            isMatchAbTest: false,
            sample_count: 0,
            count: 0,
          });
        });
      } catch (err) {
        captureError(err);
      }
      return Promise.resolve(true);
    },
    // 提交创建、复制广告计划
    async submitCreateAdgroup(store, postData) {
      let data = {};
      const { commit } = store;
      try {
        commit(types.SET_LOADING_STATE, { status: true });
        const risk_info = tool.getRiskInfo();
        data = await service.createAdgroup({ ...postData, risk_info });
        // 清除 loading 状态
        commit(types.SET_LOADING_STATE, { status: false });
      } catch (err) {
        commit(types.SET_LOADING_STATE, { status: false });
        data = {};
        captureError(err);
        return Promise.reject(new Error(err?.code));
      }
      return data;
    },
    async submitCreateRFAdgroup(store, postData) {
      const risk_info = tool.getRiskInfo();
      try {
        const resp = await request.post(apis.ad.create, { ...postData, risk_info });
        return resp;
      } catch (err) {
        if (err && err.code) {
          return err;
        }
        captureError(err);
      }
    },
    // 更新编辑广告计划updateAdgroup
    async submitUpdateAdgroup(store, postData) {
      let data = {};
      const { commit } = store;
      commit(types.SET_LOADING_STATE, { status: true });
      await service.updateAdgroup(postData).then((res) => {
        data = res;
      }).catch((err) => {
        data = err;
        captureError(err);
      }).finally(() => {
        commit(types.SET_LOADING_STATE, { status: false });
      });
      return data;
    },
    // 请求 应用地址检测，不需要验证返回
    async updateAppIcon(store, postData) {
      // 前端校验规则：status为 success 且event_id非空
      let flag = false;
      try {
        const data = await service.updateAppIcon(postData);
        if (data && data.status === 'success' && data.event_id) {
          flag = true;
        }
      } catch (err) {
        captureError(err);
      }
      return flag;
    },
    // 请求appType
    async getAppType({ state, commit }, aadvid) {
      try {
        // 后端无缺省值，为空的时候直接不调用（watch导致一开始进入的时候会调用该接口)
        if (state.ad_ref_app_id === '') return;
        const resp = await request.get(apis.ad.checkAppInstallType, {
          aadvid,
          app_id: state.ad_ref_app_id,
        });
        commit(types.SET_EXTERNAL_ACTION_MAP, resp.data.statistic_map);
      } catch (err) {
        captureError(err);
      }
    },
    // 请求appinfo
    async getAppInfo(store, params) {
      // 前端校验规则：status为 success 且event_id非空
      let appInfo = {}; // app_name,app_icon:{uri}
      try {
        const { data } = await service.getAppInfo(params);
        appInfo = (data && data.app_info) || {};
      } catch (err) {
        captureError(err);
      }
      return appInfo;
    },
    // 获取 App 的 Event list
    async getAppEventList({ commit }, args = {}) {
      let list = [];
      try {
        const resp = await service.fetchAppEvents(args);
        list = (resp && resp.data && resp.data.AppEvent) || [];
      } catch (err) {
        captureError(err);
      }
      commit(types.SET_APP_EVENT_LIST, list);
      return list;
    },
    async getStockEstimate({ commit }, { params, config }) {
      let stockEstimateData = null;
      try {
        const resp = await service.fetcStockEstimate(params, config);
        stockEstimateData = (resp && resp.data) || null;
      } catch (err) {
        // 手动取消的请求直接 reject
        if (err && err.isCancel) return Promise.reject(err);
        captureError(err);
      }
      commit(types.SET_STOCK_ESTIMATE, stockEstimateData);
      return stockEstimateData;
    },
    // 受众预估
    async getAudienceEstimate({ commit }, args = {}) {
      commit(types.SET_AUDIENCE_LOADING, true);
      commit(types.SET_AUDIENCE_ESTIMATE_SCORE, 0);
      const result = {
        score: 0, // 受众预估评估的档位
        userCount: '', // 预估人数
        upperUserCount: 0,
        lowerUserCount: 0,
        isWritable: true,
        ttpUnsupportedArea: [], // ttp 国家
      };
      try {
        const isUserCountVisible = !(args.audience?.age && String(args.audience?.age) === String([[13, 17]]));
        commit(types.SET_CAMPAIGN_PARAMS_AUDIENCE_ESTIMATE, args, { root: true });
        const res = await service.fetchAudienceEstimate(args);
        const data = res?.data || {};
        result.score = parseInt(data.estimate ?? 0, 10);
        result.isWritable = data.is_writable ?? true;
        result.upperUserCount = data.upper_user_count ?? 0;
        result.lowerUserCount = data.lower_user_count ?? 0;
        if (!isUserCountVisible) {
          result.userCount = 'NA';
        } else {
          result.userCount = data.user_count || '';

          if (result.userCount[0] === '<') {
            result.userCount = `<${currencyLocaleFormat(result.userCount, 0)}`;
          } else if (result.userCount.includes('-')) {
            result.userCount = result.userCount
              .split('-')
              .map(item => currencyLocaleFormat(item.split(',').join(''), 0))
              .join('-');
          }
        }
        result.ttpUnsupportedArea = data.ttp_unsupported_area || []; // [TTP] 普通受众预估 ttpUnsupportedArea
        result.cloverUnsupportedArea = data.clover_unsupported_area || []; // [Clover] 普通受众预估 cloverUnsupportedArea
        commit(types.SET_AUDIENCE_LOADING, false);
        commit(types.SET_AUDIENCE_FAILED, false);
      } catch (err) {
        captureError(err);
        commit(types.SET_AUDIENCE_LOADING, false);
        commit(types.SET_AUDIENCE_FAILED, true);
      }
      commit(types.SET_AUDIENCE_ESTIMATE_RESULT, result);
      commit(types.SET_AUDIENCE_ESTIMATE_SCORE, result.score);
      commit(types.SET_AUDIENCE_ESTIMATE_USER_COUNT, result.userCount);
      commit(types.SET_IS_WRITABLE, result.isWritable);
      commit(types.SET_AUDIENCE_ESTIMATE_TTP, result.ttpUnsupportedArea);
      commit(types.SET_AUDIENCE_ESTIMATE_CLOVER, result.cloverUnsupportedArea);
      return result;
    },
    async getDmp({ commit, dispatch, getters }, args = {}) {
      let list = [];
      try {
        const isRF = checkIsRF(args.objectiveType) || getters.isRF;
        const params = {
          buying_type: isRF ? buyingType.RF : buyingType.AUCTION,
        };
        list = await service.fetchDmp(params);
      } catch (err) {
        captureError(err);
      }
      commit(types.SET_DMP_INFO, list);
    },

    /** 生成受众预估的入参，调用时注意判断 data 中属性可能为 undefined 的情况 */
    generateAudienceEstimateParam({ state, getters }, data) {
      const { adInterestArr = [] } = state;

      const platform =
        data.platform instanceof Array
          ? (data.platform[0] && data.platform[0].toString()) || '0'
          : (data.platform && data.platform.toString()) || '0';
      const isNoLimitAdTags = adInterestArr.length && !data?.ad_tag_v2?.find(t => adInterestArr.find(v => +v.id === +t));

      // 考虑定向扩量的情况
      const { expansion_enabled, expansion_types } = data.targeting_expansion;
      const gender = expansion_enabled && expansion_types.includes(TargetingExpansionType.GENDER) ? 0 : data.gender;
      const age = expansion_enabled && expansion_types.includes(TargetingExpansionType.AGE) ? ['ALL'] : data.age;
      const highHouseholdIncome = data.household_income ?? [];

      // Retargeting 考虑定向扩量的情况
      const isAudienceExpand = expansion_enabled && expansion_types.includes(TargetingExpansionType.AUDIENCE);
      const retargetingTags = isAudienceExpand ? [] : data.retargeting_tags;
      const retargetingTagsExclude = isAudienceExpand ? [] : data.retargeting_tags_exclude;

      // 兴趣 & 行为定向考虑定向扩量的情况
      const isInterestBehaviorExpand = expansion_enabled && expansion_types.includes(TargetingExpansionType.INTEREST_BEHAVIOR);
      const adTagV2 = isInterestBehaviorExpand ? [] : (data.ad_tag_v2 || []);
      const inMarketTags = isInterestBehaviorExpand ? [] : data.in_market_tags ?? [];
      const interestKeywordsI18n = isInterestBehaviorExpand ? [] : (data.interest_keywords_i18n || []);
      const actionScenesV2 = isInterestBehaviorExpand ? [] : (data.action_scenes_v2 || []);
      const videoActionsV2 = isInterestBehaviorExpand ? [] : (data.video_actions_v2 || []);
      const actionCategoriesV2 = isInterestBehaviorExpand ? [] : (data.action_categories_v2 || []);
      const actionDaysV2 = isInterestBehaviorExpand ? [] : (data.action_days_v2 || []);

      const behaviorParams = {
        ad_tag_v2: isNoLimitAdTags ? [] : adTagV2.map(v => v.toString()),
        in_market_tags: inMarketTags,
        interest_keywords_i18n: interestKeywordsI18n,
        action_scenes_v2: actionScenesV2,
        video_actions_v2: videoActionsV2,
        action_categories_v2: actionCategoriesV2,
        action_days_v2: actionDaysV2,
      };

      const audience = {
        ...behaviorParams,
        platform: [platform],
        retargeting_tags: (retargetingTags || []).map(v => v.toString()),
        retargeting_tags_exclude: (retargetingTagsExclude || []).map(v => v.toString()),
        districts: data.districts ?? [],
        city: data.city.map(v => v.toString()),
        country: data.country.map(v => v.toString()),
        province: data.province.map(v => v.toString()),
        particle_locations: data.particle_locations.map(v => v.toString()),
        gender: gender.toString(),
        ac: data.ac && data.ac.includes('ALL') ? [] : data.ac.map(v => v.toString()),
        age: age && age.includes('ALL') ? [] : age.map((v = []) => v.map(v => +v)),
        language_list: data.language_list && data.language_list.includes('all') ? [] : data.language_list.map(v => v.toString()),
        android_osv: (+platform === platformEnum.ANDROID ? data.android_osv?.toString() : '') || '',
        ios_osv: (+platform === platformEnum.IOS ? data.ios_osv?.toString() : '') || '',
        device_models: data.device_models || [],
        launch_price: data.launch_price.map(v => v.toString()),
        flow_package_include: data.flow_package_include,
        flow_package_exclude: data.flow_package_exclude,
        carriers: data.carriers || [],
        app_retargeting_install: data.app_retargeting_install || false,
        app_retargeting_type: data.app_retargeting_type || null,
        retargeting_audience_rule: data.retargeting_audience_rule || null,
        automated_targeting: data.automated_targeting,
        ...(getters.isDpa ? getDpaRetargetParams(data) : {}), // dpa的受众预估参数
        household_income: highHouseholdIncome,
      };

      /** [TTP] 新格式的受众预估参数 */
      const params = {
        audience,
        objective_type: data.objective_type,
        op_sys_filter: getters.opSysFilter,
        with_signature: data.withSignature ?? false,
        ad_ref_app_id: data.ad_ref_app_id || '',
        ad_ref_pixel_id: data.ad_ref_pixel_id || '',
        product_platform_id: audience.product_platform_id, // 从audience取，会判断是否是dpa
        optimize_goal: data.optimize_goal,
        external_type: state.external_type,
        inventory_flow: (+data.inventory_flow_type === 0 && !data.inventory_flow.length)
          ? Object.keys(INVENTORY_FLOW).reduce((r, v) => {
            if (v !== 'ALL' && v !== 'OTHER') {
              r.push(INVENTORY_FLOW[v].toString());
            }
            return r;
          }, [])
          : data.inventory_flow.map(v => v.toString()),
      };
      return params;
    },

    /**
     * 设置受众预估，受众预估请求以及存储受众预估入参
     */
    async setAudienceEstimateData({
      commit, dispatch, state, getters,
    }, info = {}) {
      const isRetry = info.constructor === Object && !Object.keys(info).length;
      const { audienceEstimateData } = state;
      const data = isRetry ? { ...audienceEstimateData } : { ...info };
      const { inventory_flow: old_inventory_flow = [] } = audienceEstimateData;
      const {
        city = [],
        country = [],
        province = [],
        particle_locations = [],
        inventory_flow = [],
      } = data;
      // 没有选择地域不启用；
      // 切换版位时会置空地域，不启用（dpa除外）；
      const isLocationEmpty = !city.length && !country.length && !province.length && !particle_locations.length;
      if (
        isLocationEmpty
        || inventory_flow.length !== old_inventory_flow.length && !getters.isDpa
        || !inventory_flow.length && getters.isDpa
      ) {
        commit(types.SET_AUDIENCE_ESTIMATE_SCORE, 0);
        commit(types.SET_AUDIENCE_ESTIMATE_DATA, data);
        dispatch('triggerBrAndIe', data);
        return;
      }
      // 设备价格区间选择不正确，不重新请求
      if (data.launch_price && data.launch_price.length) {
        const [min, max] = data.launch_price;
        if (min >= max) {
          return;
        }
      }
      const params = await dispatch('generateAudienceEstimateParam', data);
      if (!isRetry) {
        const oldParams = await dispatch('generateAudienceEstimateParam', state.audienceEstimateData);
        if (!_.isEqual(data, state.audienceEstimateData)) {
          commit(types.SET_AUDIENCE_ESTIMATE_DATA, data);
        }
        if (_.isEqual(params, oldParams)) {
          dispatch('triggerBrAndIe', data);
          return;
        }
      }
      commit(types.SET_AUDIENCE_ESTIMATE_DATA, data);
      if (estimateRequestTimer) window.clearTimeout(estimateRequestTimer);
      estimateRequestTimer = window.setTimeout(async () => {
        await dispatch('getAudienceEstimate', params);
        dispatch('triggerBrAndIe', data);
      }, estimateRequestTnterval);
    },
    /** 触发 budget recommend 和 impression estimate */
    triggerBrAndIe({ state, dispatch }, adgroupData) {
      if (!state.isBudgetRecommendVisible) {
        return;
      }
      const temp = { adgroup: adgroupData, campaign: state.adCampaignData };
      dispatch('setBudgetRecommendParam', temp);
      dispatch('setImpressionEstimateParam', temp);
    },
    /** 设置 impression 预估的人数 */
    setImpressionEstimateParam({ commit, state }, data) {
      if (!data || !data?.adgroup?.budget) {
        commit(types.SET_IMPRESSION_ESTIMATE, 0);
        return;
      }
      const param = recommendBudgetRequestFormatter(data.adgroup, data.campaign, state.audienceEstimateResult);
      if (_.isEqual(param, state.impressionEstimateParam)) {
        return;
      }
      commit(types.SET_IMPRESSION_ESTIMATE_PARAM, data);
      if (impressionEstimateTimer) {
        window.clearTimeout(impressionEstimateTimer);
      }
      impressionEstimateTimer = window.setTimeout(() => {
        getImpressionService(param).then(impression => commit(types.SET_IMPRESSION_ESTIMATE, impression));
      }, estimateRequestTnterval);
    },
    /** 获取推荐预算 */
    setBudgetRecommendParam({ commit, state }, data) {
      if (!data) {
        commit(types.SET_BUDGET_RECOMMEND_DATA, undefined);
        return;
      }
      const param = recommendBudgetRequestFormatter(data.adgroup, data.campaign, state.audienceEstimateResult);
      if (_.isEqual(param, state.budgetRecommendParam)) {
        return;
      }
      commit(types.SET_BUDGET_RECOMMEND_PARAM, param);
      if (budgetRecommendTimer) {
        window.clearTimeout(budgetRecommendTimer);
      }
      budgetRecommendTimer = window.setTimeout(() => {
        getRecommendBudgetService(param).then(resData => commit(types.SET_BUDGET_RECOMMEND_DATA, resData));
      }, estimateRequestTnterval);
    },
    /** 推荐预算采纳数据回传 */
    returnRecommendBudget({ commit, state }, data) {
      if (!state.budgetRecommendParam) {
        return;
      }
      const commonParam = state.budgetRecommendParam;
      commonParam.ad_futures.id = data.adId;
      commonParam.campaign_futures.id = data.campaignId;
      const params = {
        ...commonParam,
        adopt_source: state.budgetSourceType,
        estimated_impression: {
          impression_lower: state.impressionEstimate,
        },
        recommended_budget: {
          recommended_budget_info: state.budgetRecommendData,
        },
      };
      postBackRecommendBudgetService(params);
    },
    setCityMap({ commit }, data = []) {
      commit(types.SET_CITY_MAP, [...data]);
    },
    async getAllLocationMap({ commit, dispatch, state }) {
      const param = {
        inventory_flow: JSON.stringify([3000, 1000, 9000]),
      };
      const list = await dispatch('loadAreasData', param);
      const data = cityOptions2Array(list) || [];
      commit(types.SET_ALL_LOCATION_MAP, [...data]);
    },
    setAdInterestMap({ commit }, data = []) {
      commit(types.SET_AD_INTEREST_MAP, [...data]);
    },
    setAdTopicMap({ commit }, data = []) {
      commit(types.SET_AD_TOPIC_MAP, [...data]);
    },
    setHasPreMiumTopic({ commit }, data = false) {
      commit(types.SET_HAS_PREMIUM_TOPIC, data);
    },
    async getAppList({ commit }) {
      let appList = [];
      try {
        const resp = await service.getAppList();
        appList = resp.AppList || [];
      } catch (err) {
        captureError(err);
      }
      commit(types.SET_APP_LIST, appList);
      return appList;
    },
    async getOperationSystemList({ state, commit }, data) {
      // osv传参，2或者不传是线上全版本xxx above适用落地页ios，3 ios14-, 4 ios14+
      if (state.osvToken) {
        state.osvToken.cancel();
      }
      const cancelToken = request.axios.CancelToken;
      const source = cancelToken.source();
      commit(types.SET_OSV_TOKEN, source);
      let iosList = [];
      let androidList = [];
      try {
        const resp = await service.getOperationSystemList(data, { cancelToken: source.token });
        iosList = _.map(resp.ios, (item) => {
          item.type = 'ios';
          return item;
        }) || [];
        androidList = _.map(resp.android, (item) => {
          item.type = 'android';
          return item;
        }) || [];
      } catch (err) {
        captureError(err);
      }
      commit(types.SET_IOS_LIST, iosList);
      commit(types.SET_ANDROID_LIST, androidList);
      return {
        ios: iosList,
        android: androidList,
      };
    },
    async getAllLanguagesList({ commit }) {
      let allLanguagesList = [];
      try {
        const resp = (await service.getAllLanguagesList()) || {};
        allLanguagesList = resp.language_list.map(({ code, label }) => ({ id: code, label })) || [];
      } catch (err) {
        captureError(err);
      }
      commit(types.SET_ALL_LANGUAGES_LIST, allLanguagesList);
      return allLanguagesList;
    },
    async getExternalActions({
      state, commit,
    }, data) {
      // 请求时之前的请求还没有返回直接取消
      const { isSplitTest = false, splitTestIndex = 0, updateAll = false } = data;

      if (state.externalActionToken[splitTestIndex]) {
        state.externalActionToken[splitTestIndex].cancel();
      }
      const cancelToken = request.axios.CancelToken;
      const source = cancelToken.source();
      commit(types.SET_EXTERNALACTION_TOKEN, { data: source, index: splitTestIndex });
      let externalActions = [];
      delete data.isSplitTest;
      delete data.splitTestIndex;
      delete data.updateAll;

      try {
        const resp = await service.getExternalActions(data, { cancelToken: source.token });
        externalActions = resp.events || [];
      } catch (err) {
        captureError(err);
        return false;
      }
      if (isSplitTest && updateAll) { // isSplitTest在切换app时，ab 都需要更新
        commit(types.SET_EXTERNAL_ACTIONS, externalActions);
        commit(types.SET_EXTERNAL_ACTIONS_A, externalActions);
        commit(types.SET_EXTERNAL_ACTIONS_B, externalActions);
      } else if (isSplitTest && splitTestIndex === 0) {
        commit(types.SET_EXTERNAL_ACTIONS, externalActions);
        commit(types.SET_EXTERNAL_ACTIONS_A, externalActions);
      } else if (isSplitTest && splitTestIndex === 1) {
        commit(types.SET_EXTERNAL_ACTIONS, externalActions);
        commit(types.SET_EXTERNAL_ACTIONS_B, externalActions);
      } else {
        commit(types.SET_EXTERNAL_ACTIONS, externalActions);
      }
      return externalActions;
    },
    async getPixelEventList({ commit }, data) {
      let pixelEventList = [];
      if (!(data && data.pixel_id)) {
        return;
      }
      try {
        commit(types.SET_PIXEL_EVENT_LIST_LOADING, true);
        const resp = await service.getPixelEventList(data);
        pixelEventList = resp.pixel_event_list && resp.pixel_event_list.map(item => ({
          id: item.external_action,
          verified_domain_list: item.verified_domain_list,
          name: item.external_action_i18n,
          eventName: item.pixel_event_name || '',
          status: item.activity_status || 0, // 0: not support 1:NoRecentActivity，2:Active
          total_count: item.total_count || 0,
          deprecated: item.deprecated,
        }));
        commit(types.SET_PIXEL_EVENT_LIST, pixelEventList);
        commit(types.SET_PIXEL_EVENT_LIST_LOADING, false);
      } catch (err) {
        commit(types.SET_PIXEL_EVENT_LIST, []);
        commit(types.SET_PIXEL_EVENT_LIST_LOADING, false);
        captureError(err);
      }
      return pixelEventList;
    },
    async getPixelList({ state, commit }, params) {
      if (state.pixelToken) {
        state.pixelToken.cancel();
      }
      const cancelToken = request.axios.CancelToken;
      const source = cancelToken.source();
      commit(types.SET_PIXEL_TOKEN, source);
      let pixelArr = [];
      try {
        commit(types.SET_PIXEL_LIST_LOADING, true);
        const resp = await service.getPixelList(params, {
          cancelToken: source.token,
        });
        pixelArr = resp.pixel_list.map(item => ({
          has_pcm_config: item.has_pcm_config,
          id: item.pixel_id,
          name: item.pixel_name,
          pixel_code: item.pixel_code,
          pixel_version: item.pixel_version, // 1:pixel1.0, 2:pixel2.0
          status: item.activity_status || 0, // 0: not support 1:NoRecentActivity，2:Active
          asset_relation_status: item.asset_relation_status,
          available_quota: item.available_quota,
        }));
        if (+params?.promotion_website_type === 1) {
          commit(types.SET_PIXEL_ID, (pixelArr.length && pixelArr[0].id || ''));
        }
        commit(types.SET_PIXEL_LIST, pixelArr);
        commit(types.SET_PIXEL_LIST_LOADING, false);
      } catch (err) {
        commit(types.SET_PIXEL_LIST, []);
        commit(types.SET_PIXEL_LIST_LOADING, false);
        captureError(err);
      }
      return pixelArr;
    },
    async getPixelInfoById({ commit }, data) {
      let pixelInfo = {};
      const params = {
        pixel_id: data && data.pixel_id,
        promotion_website_type: data.promotion_website_type,
      };
      try {
        const { pixel_info: resp } = await service.getPixelInfoById(params);
        const pixelEventList = (resp.pixel_events ?? []).map(item => ({
          id: item.external_action,
          verified_domain_list: item.verified_domain_list,
          name: item.external_action_i18n,
          eventName: item.pixel_event_name || '',
          total_count: item.total_count || 0,
          deprecated: item.deprecated,
        }));
        pixelInfo = {
          id: resp.pixel_id,
          has_pcm_config: resp.has_pcm_config,
          name: resp.pixel_name || '',
          pixel_code: resp.pixel_code,
          pixel_version: resp.pixel_version, // 1:pixel1.0, 2:pixel2.0
          asset_relation_status: resp.asset_relation_status,
          pixelEvents: pixelEventList,
        };
        commit(types.SET_PIXEL_INFO, pixelInfo);
      } catch (err) {
        commit(types.SET_PIXEL_INFO, {});
        captureError(err);
      }
      return pixelInfo;
    },
    async getWebRecommendUrlList({ commit }, data) {
      let urlList = [];
      try {
        // const params = { external_type: contentType.website, limit: 20 };
        urlList = await service.getRecommendUrlList(data);
        commit(types.SET_WEB_URL_LIST, urlList.urls);
      } catch (err) {
        commit(types.SET_WEB_URL_LIST, []);
        captureError(err);
      }
      return urlList;
    },

    /**
     * 加载视频和创作者相关分类选项
     * @return {Object} data { videoCategory, creatorCategory }
     */
    async loadVideoAndCreatorCategory({ commit, rootState }) {
      let res = {};
      try {
        const industryTypes = rootState.campaign.adcampaign.campaignSaved?.industry_types || [];
        const param = { industry_types: JSON.stringify(industryTypes) };
        res = await request.get(apis.ad.get_action_categort, param);
        res = res.data || {};
      } catch (e) {
        res = {};
      }
      const videoCategory = res.video_related || [];
      const creatorCategory = res.creator_related || [];
      const flattenTree = (treeData) => {
        const flattenedArr = [];
        const root = { children: treeData };
        const handleEach = (item) => {
          const label = item.label || item.i18n_value;
          flattenedArr.push({ label, translation: label, ...item });
        };
        tool.walkTreeBFS({ root, handler: handleEach });
        return flattenedArr;
      };

      /** @deprecated 临时处理下线的视频行为定向标签，在定向选择选项菜单作选项隐藏处理 | TODO 长线方案落地后移除 */
      const disableDeprecatedVideoCategory = (options) => {
        const clonedOptions = _.cloneDeep(options);
        const deprecatedOption = clonedOptions.find(option => option.id === 9); // 和定向商定目前 deprecated 标签统一归为 id 为 9 的节点的子节点
        if (deprecatedOption) {
          tool.walkTreeBFS({
            root: deprecatedOption,
            handler: (item) => {
              item.deprecated = true;
              item.visible = false;
              item.filterable = false;
            },
          });
        }

        return clonedOptions;
      };

      const handledCategory = disableDeprecatedVideoCategory(videoCategory);

      commit(types.SET_VIDEO_CATEGORY_OPTIONS, handledCategory);
      commit(types.SET_FLATTENED_VIDEO_CATEGORY_OPTIONS, flattenTree(handledCategory));
      commit(types.SET_CREATOR_CATEGORY_OPTIONS, creatorCategory);
      commit(types.SET_FLATTENED_CREATOR_CATEGORY_OPTIONS, flattenTree(creatorCategory));
      return { videoCategory, creatorCategory };
    },

    /**
     * Split test 部分
     */
    // 获取在 split test 下的 budget
    getSplitTestBudget(store, data) {
      return request.get(apis.ad.getSplitTestBudget, data);
    },
    getPower({ commit }, data) {
      return request.post(apis.ad.getPower, data).then(({ data }) => {
        commit(types.SET_POWER, data.power);
      });
    },
    // 获取rf合同的时间是否有效
    // getRfContractValidTime ({ commit }, params) {
    //   request.get(apis.ad.rfContractTime, params).then(({ data }) => {
    //     commit(types.SET_POWER, data.power);
    //   });
    //   // return data;
    // },
    getSplitTestAudienceEstimate({ state, commit, getters }, info) {
      state.splitTestAudienceEstimate.forEach(async (item, index) => {
        if (state.splitTestVars[index] === undefined) {
          const newData = {
            isEstimating: false,
            isEstimateFailed: false,
            audienceEstimateScore: 0,
            audienceEstimateUserCount: '',
            isMatchAbTest: false,
            sample_count: 0,
            count: 0,
          };
          commit(types.SET_SP_ESTIMATE_DATA, { index, data: newData });
          return;
        }

        /* const statueChange = {
          isEstimating: true,
          audienceEstimateScore: 0,
          audienceEstimateUserCount: '',
          isEstimateFailed: false,
          isMatchAbTest: false,
        };
        */
        // commit(types.SET_SP_ESTIMATE_DATA, { index, data: statueChange });
        const platform = typeof state.splitTestVars[index].platform === 'object'
          ? state.splitTestVars[index].platform : [state.splitTestVars[index].platform];
        const age = formatAge(state.splitTestVars[index].age);
        // 存量drop流量传1
        const requestParams = {
          power: 0.8,
          ab_test: true,
          ad_ref_app_id: '',
          width_signature: false,
          object_type: state.objective_type,
          op_sys_filter: getters.opSysFilter,
          optimize_goal: info.optimize_goal,
          inventory_flow: state.splitTestVars[index]?.inventory_flow,
          external_type: state.external_type,
          audience: {
            ...state.splitTestVars[index],
            platform,
            age,
          },
        };

        if (splitTestEstimateRequestTimer[index]) window.clearTimeout(splitTestEstimateRequestTimer[index]);
        splitTestEstimateRequestTimer[index] = window.setTimeout(async () => {
          try {
            const curParam = requestParams;
            const isUserCountVisible = !(curParam.age && String(curParam.age) === String([[13, 17]])); // 如果 age 只选了 13-17，受众预估人数显示为 NA
            const res = await request.post(apis.ad.splitTestAuEstimate, curParam);
            const data = res?.data || {};
            commit(types.SET_SP_ESTIMATE_DATA, {
              index,
              data: {
                isEstimating: false,
                audienceEstimateScore: parseInt(data.estimate ?? 0, 10) || 0,
                audienceEstimateUserCount: isUserCountVisible ? data.user_count || '' : 'NA',
                isMatchAbTest: data.is_match_ab_test || false,
                isEstimateFailed: false,
                count: data.count || 0,
                sample_count: data.sample_count || 0,
              },
            });
          } catch (err) {
            captureError(err);
            commit(types.SET_SP_ESTIMATE_DATA, {
              index,
              data: {
                isEstimating: false,
                audienceEstimateScore: 0,
                audienceEstimateUserCount: '',
                isEstimateFailed: true,
                isMatchAbTest: false,
                sample_count: 0,
                count: 0,
              },
            });
          }
        }, estimateRequestTnterval);
      });
    },

    getVOStatus({ state, commit }, params) {
      return request.post(apis.ad.voStatus, params)
        .then(({ data }) => {
          commit('setVOStatus', data);
        })
        .catch((err) => {
          commit('setVOStatus', {
            cost_cap_status: 200,
            roas_status: 200,
            value_optimizer_status: 200,
            highest_value_status: 200,
          });
        });
    },

    getPangleFlowPkg({ state, commit }) {
      return request.get(apis.ad.pangleFlowPkg).then(({ data }) => {
        const { flow_pack_bind_models: models } = data;
        commit(types.SET_PANGLE_FLOW_PKG, models || []);
        return data;
      });
    },

    // 清空提示信息
    clearAlertInfo({ commit }, payload = {}) {
      commit(types.CLEAR_ALERT_INFO, payload);
    },

    /** 加载设备列表 */
    async getDeviceModelsList({ state, commit }) {
      let res = {};
      try {
        res = await request.get(apis.ad.get_device_model_list);
      } catch (e) {
        res = {};
      }
      const deviceList = res?.data?.device_models || [];
      const flattenDeviceArr = [];
      const handleNode = (item) => {
        item.label = item.name;
        item.translation = item.name;
        flattenDeviceArr.push(item);
        if (_.isArray(item.children)) item.children.forEach(item => handleNode(item));
      };
      deviceList.forEach(item => handleNode(item));
      commit(types.SET_DEVICE_MODEL_LIST, flattenDeviceArr);
      return { list: deviceList, flattenList: flattenDeviceArr };
    },

    // 增加一条提示信息
    addAlertInfo({ commit }, infoData) {
      commit(types.ADD_ALERT_INFO, infoData);
    },
    sendTargetRecommendTrace({ state, commit }, adgroupIds) {
      if (!state.targetRecommendTraceInfo) return;
      (Array.isArray(adgroupIds) ? adgroupIds : [adgroupIds]).forEach((adgroupId) => {
        state.targetRecommendTraceInfo.tracer(adgroupId);
      });
      commit(types.CLEAR_TARGET_RECOMMEND_TRACE_INFO);
    },
  },
};
export default adgroup;
